function add_to_cart(product) {
  var data = { 
        "id": product,
        "quantity": 1 
    } 
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        /*
        jQuery.getJSON('/cart.js', function (cart, textStatus) { 
          $('#cart_count').html(cart.item_count);
        })
        
        return fetch('/cart?view=drawer&timestamp=' + Date.now(), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (content) {  
          content.text().then(function (html) { 
                $('#block_sidebar_cart').html(html); 
                $('#block_sidebar_cart').addClass('active');
                $('html,body').css('overflow', 'hidden') ;
            }); 
        })
        */
      }
    }); 
}

document.addEventListener('DOMContentLoaded', () => {

  if($('.home-slider')) {
    $('.home-slider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      adaptiveHeight: true,
      prevArrow:`<button class="prev">
      <svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9014 1.19775L1.00014 12.099L11.9014 23.0002" stroke="#075EC7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </button>`,
      nextArrow:`<button class="next">
      <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.90112 22.8022L12.8024 11.901L1.90112 0.999788" stroke="#075EC7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </button>`,
      dots: true,
      responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
        {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1
            }
          } 
        ]
  });
  }

  if(document.querySelector('.home-about')) {
    var paralax = document.querySelector('.home-about')
      var im = document.querySelector('.about-home__img--text')
      var im2 = document.querySelector('.about-home__img--left')
      var im3 = document.querySelector('.about-home__img--clouds')
      function offset(el) {
        const rect = el.getBoundingClientRect(),
              scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
              scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              return {top: rect.top + scrollTop, left: rect.left + scrollLeft}
      }

      function annimeScroll() {
        const paralaxHeight = paralax.offsetHeight;
        const paralaxOffset = offset(paralax).top;
        const animeStart = 1;
        const paralaxPoint = window.innerHeight - paralaxHeight / animeStart;

        if((pageYOffset > paralaxOffset - paralaxPoint) && pageYOffset < (paralaxOffset + paralaxHeight)) {
          im.classList.add('active')
          im2.classList.add('active')
          im3.classList.add('active')
        } else {
          im.classList.remove('active')
          im2.classList.remove('active')
          im3.classList.remove('active')
        }
        console.log(paralaxOffset);
      }

      window.addEventListener('scroll', annimeScroll)
  }

  if($('.sliderTop') && $('.sliderBottom')) {
    $('.sliderTop').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.sliderBottom'
    });
    $('.sliderBottom').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.sliderTop',
      focusOnSelect: true
    });
  }

  if(document.querySelector('#isRead')) {
    let input = document.querySelector('#isRead');
    let btn = document.querySelector('.btn--contact');
    btn.setAttribute('disabled', true);
    input.addEventListener('click', () => {
      if (input.checked){
        btn.removeAttribute('disabled');
      }else{
        btn.setAttribute('disabled', true);
      }
    })

  }


      

      $('.nav-hide__close').on('click', function(){
        $('.nav-hide').removeClass('active');
		$("html,body").removeClass('overflow_hidden');
      });

      $('.mob-btn').on('click', function(){
      $('.nav-hide').addClass('active');
        $("html,body").addClass('overflow_hidden');
      });

      $('.show_sub_menu').on('click', function(){
        var l=$(this).attr("id");
        $(".header_sub_menu").removeClass("mob_active");
        $("#"+l+"-menu").addClass("mob_active");
      });

      $('.show_sub_sub_menu').on('click', function(){
        var l=$(this).attr("id");
        
        $(".header_sub_sub_menu").removeClass("mob_active");
        
        $("#"+l+"-menu").addClass("mob_active");
      });



	  $(".goto_mob_menu").click(function(){
        $(".header_sub_menu").removeClass("mob_active");
      })
       $(".goto_mob_submenu").click(function(){
        $(".header_sub_sub_menu").removeClass("mob_active");
      })
      
      


  }); // end DOMContentLoaded






jQuery(document).ready(function ($) {
  
  
  if($('.product_slider_main')) {
    var current=$('.product_slider_main').data('current');
    var count=$('.product_slider_main').data('count');
    
    $('.product_slider_main').slick({ 
      slidesToScroll: 1,
       slidesToShow: 1,
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      speed: 600,
      focusOnSelect: true,
      initialSlide: current,
      asNavFor: '.product_slider_thumbail'
    })
    
    var dots = true;
    if (count < 4) dots = false;
    
    
     $('.product_slider_thumbail').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product_slider_main',
      arrows: false,
      dots: dots,
      initialSlide: current,
      infinite: false,
      focusOnSelect: true,
       responsive: [
    {
      breakpoint: 600,
      settings: {
        dots: true ,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 400,
      settings: {
         dots: true ,
        slidesToShow: 2
      }
    }
  ]
    });
  }
  
  
  if($('.product_slider_main')) {
  
  $('.product-recommendations-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1, 
      arrows: true,
      dots: true, 
      infinite: false,
      focusOnSelect: true,
       responsive: [
    {
      breakpoint: 600,
      settings: {
        dots: true ,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 400,
      settings: {
         dots: true ,
        slidesToShow: 2
      }
    }
  ]
    });
  }
  
})